/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Filter_All_ResourcesInputs */

const en_audit_filter_all_resources = /** @type {(inputs: Audit_Filter_All_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All resources`)
};

const pt_br2_audit_filter_all_resources = /** @type {(inputs: Audit_Filter_All_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os recursos`)
};

/**
* | output |
* | --- |
* | "All resources" |
*
* @param {Audit_Filter_All_ResourcesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_filter_all_resources = /** @type {((inputs?: Audit_Filter_All_ResourcesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Filter_All_ResourcesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_filter_all_resources(inputs)
	return pt_br2_audit_filter_all_resources(inputs)
});